import _ from 'lodash';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useScanDetection from 'use-scan-detection';
import PostingsApi from '../../../API/shipment/postings-api';
import ShipmentsApi from '../../../API/shipment/shipments-api';
import ShipmentWorkApi from '../../../API/shipment/work-api';
import UserApi from '../../../API/user/user-api';
import { addUser } from '../../../actions/user';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Icon } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { DateInput, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { H1, H3 } from '../../../components/Basic/WrapsStyle';
import { MAP_SKLAD_RUS, WAREHOUSES } from '../../../constans';
import { showErrorNotify, showSuccessNotify, showWarningNotify } from '../../../utils/Notiffication';
import PostingLine from './PostingLine';
import styles from './styles.module.scss';

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Sber'];
const SKLAD_LIST = ['Не выбран', ...WAREHOUSES];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '220px', // 3
  '180px', // 4
  '127px', // 5
  '120px', // 6
  '220px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '220px', // 11
  '80px', // 12
];

const STATUSES = ['Не выбран', 'Нет в наличии', 'Резерв', 'Частичный резерв', 'Излишки', 'Не хватает'];
const STATUSES_ORDERS_WB = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];
const STATUSES_ORDERS_OZON = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
];

const STATUSES_ORDERS_YANDEX = ['Не выбран'];

const STATUSES_ORDERS = {
  Ozon: STATUSES_ORDERS_OZON,
  Yandex: STATUSES_ORDERS_YANDEX,
  Wb: STATUSES_ORDERS_WB,
};

const FILTER = {
  0: 'all',
  1: 'packed',
  2: 'collected',
  3: 'not_collected',
};

const initToday = () => {
  return moment(new Date()).format('MM-DD-YYYY');
};

const CalcWeekAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 7 * 24 * 3600000);

  return start;
};

function SortingPage() {
  const user = useSelector((store) => store.user);

  const [date, setDate] = useState(initToday());
  const [namesUsers, setNamesUsers] = useState([]);
  const [statistic, setStatistic] = useState({});
  const [byNamesUsers, setByNamesUsers] = useState({});

  const [market, setMarket] = useState(MARKETS_LIST[0]);
  const [sklad, setSklad] = useState(SKLAD_LIST[0]);

  const [images, setImages] = useState([]);
  const [period, setPeriod] = useState({ startDate: new Date(moment().subtract(14, 'day')), endDate: new Date(moment().add(5, 'day')) });
  const [lastPostingMarket, setLastPostingMarket] = useState(null);

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.focus();
      // eslint-disable-next-line no-unused-expressions
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');

  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ providerId: '' });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [status, changeStatus] = useState(STATUSES[0]);
  const [orderStatus, changeOrderStatus] = useState('Не выбран');
  const [shopName, setShopName] = useState('Все');

  const [postings, setPostings] = useState([]);
  const [map, setMap] = useState({});
  const [countS, setCountS] = useState({
    count_scan: 0,
    count_packaging: 0,
    count_sort: 0,
    scan_pay: 0,
    packaging_pay: 0,
    sort_pay: 0,
  });

  //const { ids, byIds, map } = useSelector((store) => store.postings);
  const dispatch = useDispatch();

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const is_owner = user.role === 'owner';

  const addPosting = (posting, mapItem = {}) => {
    let new_p = [posting, ...postings];
    new_p = _.uniqBy(new_p, (obj) => obj.posting_number);
    setPostings(new_p.slice(0, 20));
    setMap({ ...map, ...mapItem });
    let imgs = [];
    Object.keys(mapItem).map((key) => {
      const product = mapItem[key];

      if ((product.images || []).length > 0) {
        imgs.push(product.images[0]);
      }
    });
    setImages(imgs);
    if (lastPostingMarket !== null && lastPostingMarket !== posting.market) {
    }
    setLastPostingMarket(posting.market);
    console.log(posting.market, lastPostingMarket, lastPostingMarket !== null, lastPostingMarket !== posting.market);
  };

  const loadData = () => {
    PostingsApi.getPackagingPostings({
      data: {
        users: is_owner ? undefined : [user.name],
        tab: FILTER[tab],
        limit: parseInt(show),
        search,
        providerId: is_owner ? provider.id : '',
        sortType: 'sorting',
        skladName: 'msk',
        market: is_owner ? (market == 'Не выбрана' ? undefined : market.toLowerCase()) : undefined,
        period,
        skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
      }
    })
      .then((res) => {
        const { postings, cardsMap = {}, all_count = {} } = res;
        const { all, awaiting_packaging, packaged } = all_count;

        setCountStock([all, packaged, awaiting_packaging]);
        //  почему было  так setPostings(is_owner ? postings : []);
        setPostings(postings);
        setMap(cardsMap);
      })
      .catch();
  };

  useEffect(() => {
    loadData();
  }, [tab, show, search, provider.id, market, shopName, user.login, period, sklad]);

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: 'Не выбран', id: null });
    }
  }, [allProviders]);

  const parseDetectQrPackager = (data) => {
    const detect = ':login:';
    const length = detect.length;
    const isLoginIndex = data.indexOf(detect);

    const isLogin = isLoginIndex !== -1;
    if (isLogin) {
      const indexscanerId = data.indexOf(':');
      const scanerId = data.slice(0, indexscanerId);
      const username_pass = data.slice(isLoginIndex + length);
      const [username, password] = username_pass.split('/');

      console.log('login', username, password, scanerId);

      UserApi.login({ data: { login: username, password } })
        .then((res) => {
          dispatch(addUser(res.user));
          showSuccessNotify('Пользователь изменен');
          UserApi.setScannerId({ data: { login: username, scanerId } }).then().catch();
        })
        .catch((e) => {
          showErrorNotify('');
          showErrorNotify('Ошибка, обратись к управляющему');
        });
    }
    return isLogin;
  };


  const onScanPackager = async (idPackger, barcode) => {
    await ShipmentWorkApi.sortScan({ data: { scanerId: idPackger, postingBarcode: barcode } })
      .then(({ warning, posting, cardsMap = {} }) => {
        if (warning) {
          showWarningNotify(warning);
          addPosting(posting, cardsMap);
        } else {
          showSuccessNotify('Успешно');
          setStatistic({
            ...statistic,
            [user.name]: {
              ...statistic[user.name],
              sort: { ...statistic[user.name].sort, count: statistic[user.name]['sort'].count + 1 },
            },
          });
          addPosting(posting, cardsMap);
        }
      })
      .catch();
  };
  useScanDetection({
    onComplete: async (data) => {
      let code = data.replaceAll('Shift', '');
      code = code.replaceAll('Unidentified', '');

      console.log(code);
      if (!parseDetectQrPackager(code)) {
        console.log(code);
        const index = code.indexOf(':');
        const idPackger = code.slice(0, index);
        const barcode = code.slice(index + 1);

        console.log(idPackger, barcode, barcode.length);
        if (barcode.length > 7) {
          console.log('sending...', idPackger, barcode);

          await onScanPackager(idPackger, barcode);
        }
      }
    },
  });

  useEffect(() => {
    setShopName('Все');
  }, [market]);

  useEffect(() => {
    ShipmentsApi.getUsersStatistic({ data: { users: namesUsers, date } })
      .then((r) => r.statistic)
      .then((r) => {
        setStatistic(r);

        const d = Object.keys(r || {}).map((key) => r[key]);
        const res = d.reduce(
          ({ count_scan, count_packaging, count_sort, scan_pay, packaging_pay, sort_pay }, item) => {
            return {
              count_scan: count_scan + item.pick?.count || 0,
              count_packaging: count_packaging + item.package?.count || 0,
              count_sort: count_sort + item.package?.sort || 0,

              scan_pay: scan_pay + item.pick?.pay || 0,
              packaging_pay: packaging_pay + item.package?.pay || 0,
              sort_pay: sort_pay + item.sort?.pay || 0,
            };
          },
          { count_scan: 0, count_packaging: 0, count_sort: 0, scan_pay: 0, packaging_pay: 0, sort_pay: 0 },
        );

        setCountS(res);
      })
      .catch();
  }, [namesUsers, date, user]);

  useEffect(() => {
    UserApi.getUsersByRole({})
      .then((r) => {
        const byName = {};
        const names = r.users.map((item) => {
          byName[item.name] = item;
          return item.name;
        });

        setByNamesUsers(byName);
        setNamesUsers(names);
      })
      .catch();
  }, []);

  const scan = async (barcode) => {
    onScanPackager(4, barcode);
  };

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  return (
    <Content>
      <Row style={{ alignItems: 'flex-start' }}>
        <WhiteBlock style={{ width: '600px' }}>
          <H3>Упаковка</H3>
          <DateInput
            label="Дата упаковки"
            className={styles.date_input}
            value={date}
            width={'200px'}
            onChange={(v) => setDate(new Date(v))}
          />

          <Row>
            <H1 style={{ fontSize: '60px', margin: '0', minWidth: '500px', width: 'max-content' }}>{user.name}</H1>

            <div className={styles.count_packager}>
              {(statistic[user.name] || {}).package?.count}
              {(statistic[user.name] || {}).pick?.count > 0 && (
                <span style={{ color: '#c7118f' }}>/ {(statistic[user.name] || {}).pick?.count} </span>
              )}
              {(statistic[user.name] || {}).sort?.count > 0 && (
                <span style={{ color: 'rgb(201 132 15)' }}>/ {(statistic[user.name] || {}).sort?.count} </span>
              )}
            </div>
          </Row>
        </WhiteBlock>
        {images.map((img) => (
          <Icon src={img} height={'230px'} style={{ marginLeft: '20px' }} />
        ))}
      </Row>

      <Row style={{ alignItems: 'flex-start' }}>
        <Column style={{ width: '1950px', marginRight: '20px' }}>
          <Column>
            {is_owner && (
              <WhiteBlock className={styles.search_block}>
                <Row className={styles.navigate_table}>
                  <NavTabs
                    open_tab={tab}
                    tabs={['Все заказы', 'Упакованы', 'Ожидает упаковки', 'Не обработаны']}
                    isNum={true}
                    num={countStock}
                    style_tab={styles.style_tab}
                    onChange={onChangeTab}
                  />
                </Row>
                <Row spaceBetween={true} style={{ marginTop: '20px' }}>
                  <Row style={{ height: '40px' }}>
                    <Select
                      label="Показать на странице"
                      select={show}
                      list={['20', '50', '100', '150', '200', '500', '1000']}
                      onSelect={(v) => setShow(v)}
                      width="150px"
                      style={{ marginRight: '15px' }}
                    />
                    <Select
                      list={MARKETS_LIST}
                      select={MARKETS_LIST[0]}
                      label="Площадка"
                      onSelect={(v) => setMarket(v)}
                      width={'150px'}
                      style={{ marginRight: '15px' }}
                    />
                    <Select
                      label="Поставщик"
                      select={provider}
                      valueFn={(p) => p.name}
                      list={providers}
                      width="200px"
                      onSelect={(v) => changeProvider(v)}
                      style={{ marginRight: '15px' }}
                    />
                    <Select
                      list={SKLAD_LIST}
                      select={sklad}
                      label="Склад отгрузки"
                      onSelect={(v) => setSklad(v)}
                      width={'200px'}
                    />
                  </Row>
                  <Row>
                    <Column style={{ marginRight: '10px' }}>
                      <InputLabel>Начало периода</InputLabel>
                      <Row style={{ width: '130px' }}>
                        <DateInput
                          value={period.startDate}
                          className={styles.calendar}
                          onChange={(v) => setPeriod({ ...period, startDate: new Date(v) })}
                        />
                      </Row>
                    </Column>
                    <Column style={{ marginRight: '10px' }}>
                      <InputLabel>Конец периода</InputLabel>
                      <Row style={{ width: '130px' }}>
                        <DateInput
                          value={period.endDate}
                          className={styles.calendar}
                          onChange={(v) => setPeriod({ ...period, endDate: new Date(v) })}
                        />
                      </Row>
                    </Column>
                  </Row>
                </Row>
              </WhiteBlock>
            )}

            <Table styles={styles.table}>
              <TableHeader whiteHeader>
                <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
                {is_owner && (
                  <HeaderTitle width={WIDTH_POSTING[12]} centerText>
                    Дата отгрузки
                  </HeaderTitle>
                )}
                <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[8]} centerText={true}>
                  Количество
                </HeaderTitle>
                {is_owner && (
                  <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                    Статус упаковки
                  </HeaderTitle>
                )}
                {/*      <HeaderTitle  width={WIDTH_POSTING[3]} centerText={true}>
                  Сложность упаковки
                </HeaderTitle>*/}
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Cборщик / время сборки
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Упаковщик / время упаковки
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Сортировщик / время сортировки
                </HeaderTitle>
                {is_owner && (
                  <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                    Поставщик
                  </HeaderTitle>
                )}
              </TableHeader>
              {postings.map((order) => {
                return (
                  <PostingLine
                    isAdmin={isAdmin}
                    scan={scan} // выпилить потом
                    order={order}
                    map={map}
                    is_owner={is_owner}
                    key={order.posting_number}
                  />
                );
              })}
            </Table>
            {is_owner && <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />}
          </Column>
        </Column>
      </Row>
    </Content>
  );
}

export default SortingPage;
